import React, { useEffect, useState } from "react";
import { CommonModal } from "@/core/components/commonModal/CommonModal";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import "./ProfileViewsModal.scss";
import { imageList } from "@/core/utils/imageList";

interface UserView {
  id: string;
  logo_uri: string;
  username: string;
  email: string;
  firstname: string;
  lastname: string;
  description: string;
  job_title: string;
  is_followed_by_me: boolean;
  is_following_me: boolean;
  is_me: boolean;
}

interface ProfileViewsModalProps {
  isOpen: boolean;
  onClose: () => void;
  userViews: UserView[];
  loading: boolean;
  totalViews: number;
}

export const ProfileViewsModal: React.FC<ProfileViewsModalProps> = ({
  isOpen,
  onClose,
  userViews,
  loading,
  totalViews,
}) => {
  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      icon=""
      height={600}
      width={400}
      actions={
        <div className="profile-views-modal-actions">
          <Button type="button" className="btn-primary" onClick={onClose}>
            Done
          </Button>
        </div>
      }
    >
      <div className="profile-views-modal">
        <div className="profile-views-header">
          <div className="profile-views-icon">
            <i
              className="pi pi-eye"
              style={{ fontSize: "1.5rem", color: "#6b7280" }}
            ></i>
          </div>
          <button className="close-button" onClick={onClose}>
            <i className="pi pi-times"></i>
          </button>
        </div>

        <div className="profile-views-title">
          {totalViews} profile view{totalViews !== 1 ? "s" : ""} in the last 30
          days
        </div>
        <div className="profile-views-subtitle">
          You can only see members during this time.
        </div>

        <div className="profile-views-list">
          {userViews.length > 0 ? (
            userViews.map((user) => {
              return (
                <Link
                  key={user.id}
                  to={`/users/${user.id}`}
                  className="profile-view-item"
                  onClick={onClose}
                >
                  <div className="profile-view-avatar">
                    <img
                      src={user?.logo_uri || imageList.noimage}
                      alt={`${user.firstname} ${user.lastname}`}
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        if (target.src !== imageList.noimage) {
                          target.src = imageList.noimage;
                        }
                      }}
                    />
                  </div>
                  <div className="profile-view-info">
                    <div className="profile-view-name">
                      {user.firstname} {user.lastname}
                    </div>
                    <div className="profile-view-title">
                      {user.job_title || "Member"}
                    </div>
                  </div>
                </Link>
              );
            })
          ) : (
            <div className="profile-views-empty">
              <p>No profile views in the last 30 days.</p>
            </div>
          )}
        </div>
      </div>
    </CommonModal>
  );
};
